import CloseIcon from '@mui/icons-material/Close';
import { useContext, useEffect, useState } from "react";

import { Alert, AlertTitle, IconButton } from "@mui/material";
import { format } from "date-fns";
import { updateUserMessage } from '../api/messages';
import { AccountContext } from "../context/account";
import styles from "../styles/components/user-messages.module.scss";
import { StyledMarkdown } from "./typeface";


export const UserMessages = () => {

const {
  userMessages,
  refetchUserMessages,
  setUserMessages,
} = useContext(AccountContext);
  const [hideMessages, setHideMessages] = useState<(number|string)[]>([])

  useEffect(() => {
    setHideMessages([])
  }, [])

  if (userMessages && userMessages.length === 0) return null
  
  return (
  <div className={styles.wrapper}>
  {userMessages.map((userMessage => {
      const {id, subject, message, created_at, severity} = userMessage
      if (hideMessages.includes(id)) return null

      return (
        <Alert 
          key={id} 
          severity={severity}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={async () => {
                setHideMessages((m) => [...m, id])
                // id as integer indicates server loaded messages
                // when id is a string, it's custom generated message for internal use only - no need to mark them on the server as they don't exist
                if (typeof id === 'number') {
                  await updateUserMessage({id, status: 'read'})
                }
                setUserMessages((prev) => prev ? prev.filter(m => m.id !== id) : [])
                await refetchUserMessages()
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2}}
        >
          <AlertTitle>{subject}</AlertTitle>
          <StyledMarkdown>{message}</StyledMarkdown>
          {created_at && <span className={styles.date}>Received on: {format(new Date(created_at), 'dd MMMM yyyy')}</span>}
        </Alert>
      )
    }))
  }
  </div>)
}